import Axios from "../../../../networking/intraceptor";
import { PreviewPdf, showToast } from "../../../../utils/helper/helper";
import {
    packaging_today_processing_data,
    pacaking_add_new_order,
    packaging_packing_wizard,
    packaging_stock_usage,
    // packaging_order_preview,
    packaging_confirm_order,
    packaging_bulk_delete,
    packaging_delete_single_log,
    packaging_packmed_files,
    packaging_incoming_orders,
    packaging_download_order_txt,
    packaging_prn_processing,
    packaging_liquid_processing,
    packaging_order_details,
    packaging_order_stock_data,
    packaging_all_invoices,
    packaging_view_invoice_pdf,
    packaging_invoice_details,
    packaging_update_invoice_status,
    packaging_stock_drugs,
    packaging_send_invoice_email,
    packaing_update_drug,
    packaging_change_order_status,
    packaging_get_updated_drugs,
    packaging_regenerate_invoice,
    packaging_total_incoming_orders_count,
    packaging_partial_orders,
    packaging_partial_order_pdf,
    packaging_add_pack_orders,
    packaging_cart_list,
    packaging_get_cart_logs,
    packaging_delete_package_cart,
    packaging_delete_package_prescription,
    packaging_stock_log,
    packaging_get_drug_family_data,
    analytics_top_drugs,
    analytics_drugs_packmed_orders,
    analytics_pacmed_drugs,
    analytics_top_pharmacies,
    analytics_pacmed_pharmacy_list
} from "../../../../networking/urlEndPoints";

import { getPharmacyAccountabilitySettings } from "../../../actions/auth/userProfileActions";

import * as routeName from '../../../../routes/routeName'

// Action Types
export const actionTypes = {
    TODAY_PROCESSING: {
        REQUEST: 'TODAY_PROCESSING_REQUEST',
        SUCCESS: 'TODAY_PROCESSING_SUCCESS',
        FAILURE: 'TODAY_PROCESSING_FAILURE'
    },
    ADD_PACKAGING_DATA: {
        REQUEST: 'ADD_PACKAGING_DATA_REQUEST',
        SUCCESS: 'ADD_PACKAGING_DATA_SUCCESS',
        FAILURE: 'ADD_PACKAGING_DATA_FAILURE'
    },
    PACKING_WIZARD_DATA: {
        REQUEST: 'PACKING_WIZARD_DATA_REQUEST',
        SUCCESS: 'PACKING_WIZARD_DATA_SUCCESS',
        FAILURE: 'PACKING_WIZARD_DATA_FAILURE'
    },
    STOCK_USAGE_DATA: {
        REQUEST: 'STOCK_USAGE_DATA_REQUEST',
        SUCCESS: 'STOCK_USAGE_DATA_SUCCESS',
        FAILURE: 'STOCK_USAGE_DATA_FAILURE'
    },
    PACKAGING_ORDER_PREVIEW: {
        REQUEST: 'PACKAGING_ORDER_PREVIEW_REQUEST',
        SUCCESS: 'PACKAGING_ORDER_PREVIEW_SUCCESS',
        FAILURE: 'PACKAGING_ORDER_PREVIEW_FAILURE'
    },
    PACKMED_FILES: {
        REQUEST: 'PACKMED_FILES_REQUEST',
        SUCCESS: 'PACKMED_FILES_SUCCESS',
        FAILURE: 'PACKMED_FILES_FAILURE'
    },
    ALL_ORDERS: {
        REQUEST: 'ALL_ORDERS_REQUEST',
        SUCCESS: 'ALL_ORDERS_SUCCESS',
        FAILURE: 'ALL_ORDERS_FAILURE'
    },
    PRN_PROCESSING: {
        REQUEST: 'PRN_PROCESSING_REQUEST',
        SUCCESS: 'PRN_PROCESSING_SUCCESS',
        FAILURE: 'PRN_PROCESSING_FAILURE'
    },
    PACKING_LIQUID_PROCESSING: {
        REQUEST: 'PACKING_LIQUID_PROCESSING_REQUEST',
        SUCCESS: 'PACKING_LIQUID_PROCESSING_SUCCESS',
        FAILURE: 'PACKING_LIQUID_PROCESSING_FAILURE'
    },
    ORDER_DETAILS: {
        REQUEST: 'ORDER_DETAILS_REQUEST',
        SUCCESS: 'ORDER_DETAILS_SUCCESS',
        FAILURE: 'ORDER_DETAILS_FAILURE'
    },
    VIEW_ORDER_DETAILS: {
        REQUEST: 'VIEW_ORDER_DETAILS_REQUEST',
        SUCCESS: 'VIEW_ORDER_DETAILS_SUCCESS',
        FAILURE: 'VIEW_ORDER_DETAILS_FAILURE'
    },
    ALL_INVOICES: {
        REQUEST: 'ALL_INVOICES_REQUEST',
        SUCCESS: 'ALL_INVOICES_SUCCESS',
        FAILURE: 'ALL_INVOICES_FAILURE'
    },
    INVOICE_DETAILS: {
        REQUEST: 'INVOICE_DETAILS_REQUEST',
        SUCCESS: 'INVOICE_DETAILS_SUCCESS',
        FAILURE: 'INVOICE_DETAILS_FAILURE'
    },
    FETCH_PHARMACY_PHARMACIST: {
        REQUEST: 'FETCH_PHARMACY_PHARMACIST_REQUEST',
        SUCCESS: 'FETCH_PHARMACY_PHARMACIST_SUCCESS',
        FAILURE: 'FETCH_PHARMACY_PHARMACIST_FAILURE'
    },
    FETCH_PARTIAL_ORDERS: {
        REQUEST: 'FETCH_PARTIAL_ORDERS_REQUEST',
        SUCCESS: 'FETCH_PARTIAL_ORDERS_SUCCESS',
        FAILURE: 'FETCH_PARTIAL_ORDERS_FAILURE'
    },
    FETCH_DASHBOARD_COUNTS: {
        REQUEST: 'FETCH_DASHBOARD_COUNTS_REQUEST',
        SUCCESS: 'FETCH_DASHBOARD_COUNTS_SUCCESS',
        FAILURE: 'FETCH_DASHBOARD_COUNTS_FAILURE'
    },
    FETCH_PACKAGING_CART_LIST: {
        REQUEST: 'FETCH_PACKAGING_CART_LIST_REQUEST',
        SUCCESS: 'FETCH_PACKAGING_CART_LIST_SUCCESS',
        FAILURE: 'FETCH_PACKAGING_CART_LIST_FAILURE'
    },
    DELETE_PACKAGE_CART: {
        REQUEST: 'DELETE_PACKAGE_CART_REQUEST',
        SUCCESS: 'DELETE_PACKAGE_CART_SUCCESS',
        FAILURE: 'DELETE_PACKAGE_CART_FAILURE'
    },
    STOCK_LOG: {
        REQUEST: 'STOCK_LOG_REQUEST',
        SUCCESS: 'STOCK_LOG_SUCCESS',
        FAILURE: 'STOCK_LOG_FAILURE'
    },
    FETCH_DRUG_FAMILY_DATA: {
        REQUEST: 'FETCH_DRUG_FAMILY_DATA_REQUEST',
        SUCCESS: 'FETCH_DRUG_FAMILY_DATA_SUCCESS',
        FAILURE: 'FETCH_DRUG_FAMILY_DATA_FAILURE'
    },
    FETCH_TOP_DRUGS_ANALYTICS: {
        REQUEST: 'FETCH_TOP_DRUGS_ANALYTICS_REQUEST',
        SUCCESS: 'FETCH_TOP_DRUGS_ANALYTICS_SUCCESS',
        FAILURE: 'FETCH_TOP_DRUGS_ANALYTICS_FAILURE'
    },
    FETCH_DRUGS_SUMMARY_ANALYTICS: {
        REQUEST: 'FETCH_DRUGS_SUMMARY_ANALYTICS_REQUEST',
        SUCCESS: 'FETCH_DRUGS_SUMMARY_ANALYTICS_SUCCESS',
        FAILURE: 'FETCH_DRUGS_SUMMARY_ANALYTICS_FAILURE'
    },
    FETCH_PACMED_DRUGS_ANALYTICS: {
        REQUEST: 'FETCH_PACMED_DRUGS_ANALYTICS_REQUEST',
        SUCCESS: 'FETCH_PACMED_DRUGS_ANALYTICS_SUCCESS',
        FAILURE: 'FETCH_PACMED_DRUGS_ANALYTICS_FAILURE'
    },
    FETCH_TOP_PHARMACIES_ANALYTICS: {
        REQUEST: 'FETCH_TOP_PHARMACIES_ANALYTICS_REQUEST',
        SUCCESS: 'FETCH_TOP_PHARMACIES_ANALYTICS_SUCCESS',
        FAILURE: 'FETCH_TOP_PHARMACIES_ANALYTICS_FAILURE'
    },
    FETCH_PACKMED_PHARMACY_LIST: {
        REQUEST: 'FETCH_PACKMED_PHARMACY_LIST_REQUEST',
        SUCCESS: 'FETCH_PACKMED_PHARMACY_LIST_SUCCESS',
        FAILURE: 'FETCH_PACKMED_PHARMACY_LIST_FAILURE'
    }
};

// Action Creators
export const createAction = (type, payload = {}) => ({ type, payload });

// Generates a new packaging order, handles navigation to wizard view if successful
export const GenrateNewOrder = ({ payloadData, fetchType, navigate }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(pacaking_add_new_order, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            const orderIds = response?.data?.data?.order_ids
            if (orderIds?.length > 0) {
                sessionStorage.removeItem('packageData')
                navigate(`${routeName.pharmacy_packaging_processing}?type=wizard&order_ids=${orderIds}`);
                dispatch(FetchPackingWizardData({
                    type: 'packaging_packing_wizard', orderIds,
                    formData: {
                        routes: '', dates: '',
                        type: { label: 'All', value: 'All' }
                    }
                }))
            }
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred',
            requestType: fetchType
        }));
    }
};

// Fetches and updates today's processing data for packaging
export const FetchTodayProcessingData = ({ type, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.TODAY_PROCESSING.REQUEST, {
        requestType: type
    }));
    try {
        const response = await Axios.get(`${packaging_today_processing_data}?page=${pageNumber}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.TODAY_PROCESSING.SUCCESS, {
                data: response.data,
                requestType: type
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.TODAY_PROCESSING.FAILURE, {
            error: error?.response?.data || 'An error occurred',
            requestType: type
        }));
    }
};

// Fetches packing wizard data with optional filters for routes, dates, and emergency status
export const FetchPackingWizardData = ({ type, orderIds, formData, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PACKING_WIZARD_DATA.REQUEST, {
        requestType: type
    }));
    try {
  const { routes, dates, type, witness, drug, drug_family, patientsearch, facility } = formData

        const params = {
            order_ids: orderIds,
            ...(routes && { filterroute: routes?.label === 'All' ? routes?.label?.toLowerCase() : routes?.label }),
            ...(dates && { filterdate: dates?.label === 'All' ? dates?.label?.toLowerCase() : dates?.label }),
      filteremergency: type?.label?.toLowerCase(),
      ...(witness && { filterwitness: witness?.value?.toLowerCase() }),
            page: pageNumber,
            ...(drug && { filterdindrug: drug }),
            ...(drug_family && { filterdrugfamily: drug_family?.label }),
            ...(patientsearch && { patientsearch: patientsearch }),
            ...(facility && { pahomefilter: facility?.label === 'All' ? facility?.label?.toLowerCase() : facility?.label })
        }

        const response = await Axios.get(packaging_packing_wizard, { params });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PACKING_WIZARD_DATA.SUCCESS, {
                data: response.data,
                requestType: type
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PACKING_WIZARD_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred',
            requestType: type
        }));
    }
};

// Retrieves stock usage data for specified order IDs
export const FetchStockUsageData = ({ type, orderIds }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.STOCK_USAGE_DATA.REQUEST, {
            requestType: type
        }));
        const response = await Axios.get(packaging_stock_usage, { params: { order_ids: orderIds } });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.STOCK_USAGE_DATA.SUCCESS, {
                data: response.data,
                requestType: type
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.STOCK_USAGE_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred',
            requestType: type
        }));
    }
}

// Fetches preview data for packaging orders before confirmation
// export const FetchPackagingOrderPreviewData = ({ type, payloadData }) => async (dispatch) => {
//     try {
//         dispatch(createAction(actionTypes.PACKAGING_ORDER_PREVIEW.REQUEST, {
//             requestType: type
//         }));
//         const response = await Axios.post(packaging_order_preview, payloadData);
//         if (response.status === 200) {
//             dispatch(createAction(actionTypes.PACKAGING_ORDER_PREVIEW.SUCCESS, {
//                 data: response.data,
//                 requestType: type
//             }));
//         }
//     } catch (error) {
//         dispatch(createAction(actionTypes.PACKAGING_ORDER_PREVIEW.FAILURE, {
//             error: error?.response?.data || 'An error occurred',
//             requestType: type
//         }));
//     }
// }

export const FetchPackagingOrderPreviewData = ({ type, packageId, pageNumber = 1 }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.PACKAGING_ORDER_PREVIEW.REQUEST, {
            requestType: type
        }));
        const response = await Axios.get(packaging_get_cart_logs, {
            params: {
                cart_id: packageId,
                page: pageNumber
            }
        });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PACKAGING_ORDER_PREVIEW.SUCCESS, {
                data: response.data,
                requestType: type
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PACKAGING_ORDER_PREVIEW.FAILURE, {
            error: error?.response?.data || 'An error occurred',
            requestType: type
        }));
    }
}

// Creates and confirms a packaging order, then follows the fulfilment-aware redirect from the backend.
export const CreatePackagingOrder = ({ payloadData, fetchType, navigate }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(packaging_confirm_order, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            if (response?.data?.success) {
                sessionStorage.removeItem('packageData')
                showToast('Order created successfully', 'success')
                if (response?.data?.redirect) {
                    navigate(`${routeName.pharmacy_packaging_all_d_logs}`)
                } else {
                    navigate(`${routeName.pharmacy_packaging_orders}`)
                }
            }
        }
    } catch (error) {
        showToast('Oops we got an error while creating order please try again later', 'error')
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while creating order please try again later',
            requestType: fetchType
        }));
    }
};




// Handles bulk deletion of selected prescriptions in packing wizard
export const PackingWizardBulkDelete = ({ payloadData,
    fetchType,
    orderIds,
    setSelectedPrescriptions,
    formData,
    pageNumber


}) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(packaging_bulk_delete, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            setSelectedPrescriptions([])
            dispatch(FetchPackingWizardData({
                type: 'packaging_packing_wizard',
                orderIds,
                formData,
                pageNumber
            }))
            showToast('Records deleted successfully', 'success');
        }
    } catch (error) {
        showToast('Oops we got an error while deleting records please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while deleting records please try again later',
            requestType: fetchType
        }));
    }
}

// Handles deletion of a single prescription log in packing wizard
export const PackingWizardDelete = ({ payloadData,
    fetchType,
    orderIds,
    pageNumber,
    formData
}) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.delete(packaging_delete_single_log, { data: payloadData });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            dispatch(FetchPackingWizardData({
                type: 'packaging_packing_wizard',
                orderIds,
                formData,
                pageNumber
            }))
            showToast('Record deleted successfully', 'success');
        }
    } catch (error) {
        showToast('Oops we got an error while deleting records please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while deleting records please try again later',
            requestType: fetchType
        }));
    }
}

// Fetches packmed files data
export const FetchPackmedFiles = ({ fetchType, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PACKMED_FILES.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_packmed_files}?page=${pageNumber}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PACKMED_FILES.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PACKMED_FILES.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while deleting records please try again later',
            requestType: fetchType
        }));
    }
}

// Retrieves all incoming orders data
export const FetchAllIncomingOrders = ({ fetchType, formData, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ALL_ORDERS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const order_status = formData?.status?.label === 'All' ? 0 : formData?.status?.label?.toLowerCase()
        const response = await Axios.get(`${packaging_incoming_orders}?order_status=${order_status}&page=${pageNumber}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ALL_ORDERS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ALL_ORDERS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Downloads packmed order text file in plain text format
export const PackMedTextFileDownload = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_download_order_txt}/${id}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));

            // Convert base64 to text and download
            const content = atob(response?.data?.file_base64);
            const blob = new Blob([content], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = response?.data?.file_name || 'download.txt';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        showToast('Oops we got an error while downloading file please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Downloads packmed order files as a zip archive
export const PackMedZipFileDownload = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        // Modify the Axios request to handle binary data
        const response = await Axios.get(`${packaging_download_order_txt}/${id}?zipdownload=${1}`, {
            responseType: 'arraybuffer'  // This is crucial for binary data
        });

        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            // Create blob directly from the array buffer
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `order_${id}.zip`; // You can set a specific name if provided by the API
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        showToast('Oops we got an error while downloading zip please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Downloads specific package file based on package number
export const PackMedPackageDownload = ({ fetchType, id, packageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_download_order_txt}/${id}?package_number=${packageNumber}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));

            // Convert base64 to text and download
            const content = atob(response?.data?.file_base64);
            const blob = new Blob([content], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = response?.data?.file_name || 'download.txt';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        showToast('Oops we got an error while downloading file please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Fetches PRN (Pro Re Nata/as needed) processing data
export const FetchPackgingPRN_Processing = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PRN_PROCESSING.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(packaging_prn_processing);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PRN_PROCESSING.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PRN_PROCESSING.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Fetches liquid medication processing data
export const FetchPackgingLiquidProcessing = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PACKING_LIQUID_PROCESSING.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(packaging_liquid_processing);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PACKING_LIQUID_PROCESSING.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PACKING_LIQUID_PROCESSING.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Retrieves detailed order information with optional view type
export const FetchOrderDetails = ({ fetchType, id, viewType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ORDER_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {

        const response = await Axios.get(`${packaging_order_details}/${id}/patient-view?viewType=${viewType}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ORDER_DETAILS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ORDER_DETAILS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Retrieves detailed order information with optional view type
export const FetchViewOrderDetails = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.VIEW_ORDER_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_order_details}/${id}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.VIEW_ORDER_DETAILS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.VIEW_ORDER_DETAILS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Retrieves detailed order information with optional view type
export const FetchStockWiseOrderDetails = ({ fetchType, id, setStockWiseLoading }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ORDER_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            order_id: id
        }
        const response = await Axios.post(`${packaging_order_stock_data}`, params);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ORDER_DETAILS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            if (typeof setStockWiseLoading === 'function') {
                setStockWiseLoading(false)
            }
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ORDER_DETAILS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
        if (typeof setStockWiseLoading === 'function') {
            setStockWiseLoading(false)
        }
    }
}

// Fetches Invoice data
export const FetchAllInvoices = ({ fetchType, formData, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ALL_INVOICES.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            payment_status: formData?.payment_status?.label === 'All Payment Status' ? 0 : formData?.payment_status?.label?.toLowerCase(),
            invoice_status: formData?.invoice_status?.label === 'All Invoice Status' ? 0 : formData?.invoice_status?.label?.toLowerCase(),
            search_date: formData?.date,
            pharmacy_details: formData?.pharmacy_details,
            page: pageNumber
        }

        const response = await Axios.get(packaging_all_invoices, { params });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ALL_INVOICES.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ALL_INVOICES.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

export const ViewInvoicePDF = ({ fetchType, invoiceId }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_view_invoice_pdf}/${invoiceId}`);
        if (response.status === 200) {
            PreviewPdf(response?.data?.data?.invoice_pdf);
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        // console.log(error)
        showToast('Oops we got an error while fetching invoice pdf please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while fetching invoice pdf please try again later',
            requestType: fetchType
        }));
    }
}

export const FetchInvoiceDetails = ({ fetchType, invoiceId }) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVOICE_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_invoice_details}/${invoiceId}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.INVOICE_DETAILS.SUCCESS, {
                data: response?.data.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        // console.log(error)
        showToast('Oops we got an error while fetching invoice pdf please try again later', 'error');
        dispatch(createAction(actionTypes.INVOICE_DETAILS.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while fetching invoice pdf please try again later',
            requestType: fetchType
        }));
    }
}

//Invoice Payment Status Update
export const ChangePaymentStatus = ({ fetchType, payloadData, setShowModal, pageNumber, formData }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(`${packaging_update_invoice_status}`, payloadData);
        if (response.status === 200) {
            dispatch(FetchAllInvoices({ fetchType: 'allInvoices', pageNumber, formData }))
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            setShowModal(false)
            showToast('Status updated successfully', 'success');
        }
    } catch (error) {
        // console.log(error)
        showToast('Oops we got an error while fetching invoice Paid or Unpaid Status please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while fetching invoice Paid or Unpaid Status please try again later',
            requestType: fetchType
        }));
    }
}

//Send Invoice Email
export const SendInvoiceEmail = ({ fetchType, payloadData, setShowModal }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(`${packaging_send_invoice_email}`, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            setShowModal(false)
            showToast('Email sent successfully', 'success');
        }
    } catch (error) {
        showToast('Oops we  an error while sending invoice email please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while sending invoice email please try again later',
            requestType: fetchType
        }));
    }
}

//Invoice Payment Status Update
export const FetchStockDrugs = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${packaging_stock_drugs}`, { params: payload });
        if (response.status === 200) {
            if (response?.data?.drugs) {
                dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                    data: response?.data?.drugs,
                    requestType: 'drugs'
                }));
            } else {
                dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                    data: response?.data?.message,
                    requestType: fetchType
                }));
            }
        }
    } catch (error) {
        showToast('Oops we got an error while fetching stock drugs please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


//Update Drug Stock
export const HandleUpdateDrug = ({ payload, setShowModal, setLoading, setActiveTooltip, setStockWiseLoading }) => async (dispatch) => {

    try {
        if (typeof setLoading === 'function') {
            setLoading(true)
        }
        const response = await Axios.post(`${packaing_update_drug}`, payload);
        if (response.status === 200) {
            showToast(response?.data?.message, 'success');
            dispatch(FetchStockWiseOrderDetails({
                fetchType: 'stockViewOrderDetails',
                id: payload?.order_id,
                setStockWiseLoading
            }))
            setShowModal((prev) => ({ ...prev, drug: false }))
            setActiveTooltip(null)
            if (typeof setLoading === 'function') {
                setLoading(false)
            }
        }
    } catch (error) {
        showToast('Oops we got an error while updating drug stock please try again later', 'error');
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
    }
}


//Update Drug Stock
export const HandleChangeOrderStatus = ({ payload, orderId, viewType, pharmacyId, setLoading, setShowModal, showModal }) => async (dispatch) => {
    try {
        if (typeof setLoading === 'function') {
            setLoading(true)
        }
        const response = await Axios.post(`${packaging_change_order_status}`, payload);
        if (response.status === 200) {

            showToast(response?.data?.message || 'Status updated successfully', 'success');

            if (typeof setShowModal === 'function' && payload?.order_status == 'delivered') {
                setShowModal({ ...showModal, status: false })
            }

            if (orderId && viewType !== 'stockview') {
                dispatch(FetchOrderDetails({
                    fetchType: 'orderDetails',
                    id: orderId,
                    viewType: viewType
                }))
            } else if (orderId && viewType == 'stockview' && pharmacyId == 1502) {
                dispatch(FetchStockWiseOrderDetails({
                    fetchType: 'stockViewOrderDetails',
                    id: orderId
                }))
            }
            if (orderId) {
                dispatch(FetchViewOrderDetails({
                    fetchType: 'viewOrderDetails',
                    id: orderId
                }))
            }
            if (typeof setLoading === 'function') {
                setLoading(false)
            }

        }
    } catch (error) {
        showToast('Oops we got an error while updating status please try again later', 'error');
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
    }
}

//Update Drug Stock
export const HandleGetUpdatedDrugs = ({ payload, fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${packaging_get_updated_drugs}/${payload?.order_id}`);
        if (response.status === 200) {
            PreviewPdf(response?.data?.pdf_base64)
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {

        showToast('Oops we got an error while fetching updated drugs please try again later', 'error');

        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Handle Partial Order
export const HandleGetPartialOrder = ({ payload, fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${packaging_partial_order_pdf}/${payload?.order_id}`);
        if (response.status === 200) {
            PreviewPdf(response?.data?.pdf_base64)
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {

        showToast('Oops we got an error while fetching partial order please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


//Regenerate Invoice
export const HandleRegenerateInvoice = ({ payload, fetchType, setShowModal, showModal }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.post(`${packaging_regenerate_invoice}`, payload);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));

            if (payload?.order_id) {
                dispatch(FetchViewOrderDetails({
                    fetchType: 'viewOrderDetails',
                    id: payload?.order_id
                }))
            }
            setShowModal({ ...showModal, genrate: false })
        }
    } catch (error) {
        showToast(error?.response?.data?.error || 'Oops we got an error while regenerating invoice please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


//Fetch Total Incoming Orders Count
let getTotalIncomingOrdersCountAbortControllers = []
export const FetchTotalIncomingOrdersCount = ({ setOrdersCount }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    getTotalIncomingOrdersCountAbortControllers.forEach(controller => controller.abort());
    getTotalIncomingOrdersCountAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    getTotalIncomingOrdersCountAbortControllers.push(controller);

    try {
        const response = await Axios.get(`${packaging_total_incoming_orders_count}`, { signal: controller.signal });
        if (response.status === 200) {
          
            if (typeof setOrdersCount === 'function') {
                setOrdersCount(response?.data?.data)
            }
            dispatch(createAction(actionTypes.FETCH_DASHBOARD_COUNTS.SUCCESS, {
                data: response?.data?.data,
                requestType: 'fetchTotalIncomingOrdersCount'
            }));
            const finalchk_at = response?.data?.data?.final_chk_at
            dispatch(getPharmacyAccountabilitySettings(finalchk_at))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DASHBOARD_COUNTS.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: 'fetchTotalIncomingOrdersCount'
        }));
    }
}

//Fetch Total Missed Rx Count
export const FetchTotalMissedRxCount = () => async (dispatch) => {
    try {
        const response = await Axios.get(`${packaging_total_incoming_orders_count}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_DASHBOARD_COUNTS.SUCCESS, {
                data: response?.data?.data,
                requestType: 'fetchTotalIncomingOrdersCount'
            }));
            const finalchk_at = response?.data?.data?.final_chk_at
            dispatch(getPharmacyAccountabilitySettings(finalchk_at))
        }
    } catch (error) {

    }
}

//Fetch Pharmacy Pharmacist
export const FetchPharmacyPharmacists = ({ fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.FETCH_PHARMACY_PHARMACIST.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`pharmacy-pharmacist-users`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_PHARMACY_PHARMACIST.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_PHARMACY_PHARMACIST.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Fetch Partial Orders
export const FetchPartialOrders = ({ fetchType, id }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.FETCH_PARTIAL_ORDERS.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${packaging_partial_orders}/${id}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_PARTIAL_ORDERS.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_PARTIAL_ORDERS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


// Creates and confirms a packaging order, handles navigation based on pharmacy ID
export const AddPackOrders = ({ payloadData, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(packaging_add_pack_orders, payloadData);
        if (response.status === 200) {

            dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            dispatch(FetchPackagingCartList({
                fetchType: 'fetchPackagingCartList'
            }))
        }
    } catch (error) {
        showToast('Oops we got an error while adding pack orders please try again later', 'error')
        dispatch(createAction(actionTypes.ADD_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while adding pack orders please try again later',
            requestType: fetchType
        }));
    }
};

//Fetch Packaging Cart List
export const FetchPackagingCartList = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_PACKAGING_CART_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(packaging_cart_list);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_PACKAGING_CART_LIST.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));

        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_PACKAGING_CART_LIST.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


export const DeletePackageCart = ({ payloadData, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DELETE_PACKAGE_CART.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(packaging_delete_package_cart, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.DELETE_PACKAGE_CART.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            dispatch(FetchPackagingCartList({
                fetchType: 'fetchPackagingCartList'
            }))
        }
    } catch (error) {
        showToast('Oops we got an error while deleting package cart please try again later', 'error')
        dispatch(createAction(actionTypes.DELETE_PACKAGE_CART.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

export const DeletePackagePrescription = ({ payloadData, fetchType, pageNumber = 1 }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DELETE_PACKAGE_CART.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(packaging_delete_package_prescription, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.DELETE_PACKAGE_CART.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));

            dispatch(FetchPackagingOrderPreviewData({
                type: 'packaging_order_preview',
                packageId: payloadData?.cart_id,
                pageNumber: pageNumber
            }));
        }
    } catch (error) {
        showToast('Oops we got an error while deleting package cart please try again later', 'error')
        dispatch(createAction(actionTypes.DELETE_PACKAGE_CART.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Handle Get Stock Log
export const HandleGetStockLog = ({ orderId, fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.STOCK_LOG.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${packaging_stock_log}?order_id=${orderId}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.STOCK_LOG.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.STOCK_LOG.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Fetch Drug Family Data
export const FetchDrugFamilyData = ({ fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(packaging_get_drug_family_data);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


// Analytics Actions

let fetchPackmedPharmacyListAbortControllers = []
export const FetchPackmedPharmacyList = ({ fetchType, pageNumber = 1 }) => async (dispatch) => {
    fetchPackmedPharmacyListAbortControllers.forEach(controller => controller.abort());
    fetchPackmedPharmacyListAbortControllers = [];
    const controller = new AbortController();
    fetchPackmedPharmacyListAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_PACKMED_PHARMACY_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            no_of_records: 2,
            page: pageNumber,
        }
        const response = await Axios.get(analytics_pacmed_pharmacy_list, { params, signal: controller.signal });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_PACKMED_PHARMACY_LIST.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_PACKMED_PHARMACY_LIST.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

let fetchTopPharmaciesAnalyticsAbortControllers = []
export const FetchTopPharmaciesAnalytics = ({ fetchType }) => async (dispatch) => {
    fetchTopPharmaciesAnalyticsAbortControllers.forEach(controller => controller.abort());
    fetchTopPharmaciesAnalyticsAbortControllers = [];
    const controller = new AbortController();
    fetchTopPharmaciesAnalyticsAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_TOP_PHARMACIES_ANALYTICS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(analytics_top_pharmacies, { signal: controller.signal });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_TOP_PHARMACIES_ANALYTICS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_TOP_PHARMACIES_ANALYTICS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

let fetchTopDrugsAnalyticsAbortControllers = []
export const FetchTopDrugsAnalytics = ({ fetchType, pageNumber = 1, isPharmacy, formData }) => async (dispatch) => {
    fetchTopDrugsAnalyticsAbortControllers.forEach(controller => controller.abort());
    fetchTopDrugsAnalyticsAbortControllers = [];
    const controller = new AbortController();
    fetchTopDrugsAnalyticsAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_TOP_DRUGS_ANALYTICS.REQUEST, {
        requestType: fetchType
    }));
   
    try {
        const params = {
            no_of_records: 10,
            page: pageNumber,
        }
        if(isPharmacy === false){
            params.type = formData?.type ? formData?.type : ''
        }
        const response = await Axios.get(analytics_top_drugs, { params, signal: controller.signal });
        
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_TOP_DRUGS_ANALYTICS.SUCCESS, {
                data: response.data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_TOP_DRUGS_ANALYTICS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

let fetchDrugsSummaryAnalyticsAbortControllers = []
export const FetchDrugsSummaryAnalytics = ({ fetchType, formData, isPharmacy }) => async (dispatch) => {
    fetchDrugsSummaryAnalyticsAbortControllers.forEach(controller => controller.abort());
    fetchDrugsSummaryAnalyticsAbortControllers = [];
    const controller = new AbortController();
    fetchDrugsSummaryAnalyticsAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_DRUGS_SUMMARY_ANALYTICS.REQUEST, {
        requestType: fetchType
    }));
    try {
        // Clean and validate parameters
        const params = {
            pharmacy: formData?.pharmacy?.label || formData?.pharmacy || '',
            drug: formData?.drug?.label || formData?.drug || '',
            status: formData?.status?.label ? formData.status.label.toLowerCase() : formData?.status || '',
            date_status: formData?.date_status?.value,
        }

        if(isPharmacy === false){
            params.type = formData?.type ? formData?.type : ''
        }
        
        // Remove empty parameters to avoid sending empty strings
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '')
        );

        
        const response = await Axios.get(analytics_drugs_packmed_orders, { params: cleanParams, signal: controller.signal });
        
        
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUGS_SUMMARY_ANALYTICS.SUCCESS, {
                data: response.data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DRUGS_SUMMARY_ANALYTICS.FAILURE, {
            error: error?.response?.data || 'An error occurred while fetching analytics data.',
            requestType: fetchType
        }));
    }
}

let fetchPacmedDrugsAnalyticsAbortControllers = []
export const FetchPacmedDrugsAnalytics = ({ fetchType, formData, isPharmacy }) => async (dispatch) => {
    fetchPacmedDrugsAnalyticsAbortControllers.forEach(controller => controller.abort());
    fetchPacmedDrugsAnalyticsAbortControllers = [];
    const controller = new AbortController();
    fetchPacmedDrugsAnalyticsAbortControllers.push(controller);
    dispatch(createAction(actionTypes.FETCH_PACMED_DRUGS_ANALYTICS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const params = {}
        if(isPharmacy === false){
            params.type = formData?.type ? formData?.type : ''
        }

        const response = await Axios.get(analytics_pacmed_drugs, { params, signal: controller.signal });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_PACMED_DRUGS_ANALYTICS.SUCCESS, {
                data: response.data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_PACMED_DRUGS_ANALYTICS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


// Initial State
const initialState = {
    todayProcessingData: { data: null, loading: false, error: null, fetchType: null },
    addPackagingData: { loading: false, error: null, data: null, fetchType: null },
    packingWizardData: { loading: false, error: null, data: null, fetchType: null },
    stockUsageData: { loading: false, error: null, data: null, fetchType: null },
    packagingOrderPreviewData: { loading: false, error: null, data: null, fetchType: null },
    packmedFiles: { loading: false, error: null, data: null, fetchType: null },
    allOrders: { loading: false, error: null, data: null, fetchType: null },
    prnProcessingData: { loading: false, error: null, data: null, fetchType: null },
    packgingLiquidProcessingData: { loading: false, error: null, data: null, fetchType: null },
    orderDetails: { loading: false, error: null, data: null, fetchType: null },
    viewOrderDetails: { loading: false, error: null, data: null, fetchType: null },
    allInvoices: { loading: false, error: null, data: null, fetchType: null },
    invoiceDetails: { loading: false, error: null, data: null, fetchType: null },
    fetchPharmacyPharmacist: { loading: false, error: null, data: null, fetchType: null },
    fetchPartialOrders: { loading: false, error: null, data: null, fetchType: null },
    fetchDashboardCounts: { loading: false, error: null, data: null, fetchType: null },
    fetchPackagingCartList: { loading: false, error: null, data: null, fetchType: null },
    deletePackageCart: { loading: false, error: null, data: null, fetchType: null },
    stockLog: { loading: false, error: null, data: null, fetchType: null },
    fetchDrugFamilyData: { loading: false, error: null, data: null, fetchType: null },
    fetchTopDrugsAnalytics: { loading: false, error: null, data: null, fetchType: null },
    fetchDrugsSummaryAnalytics: { loading: false, error: null, data: null, fetchType: null },
    fetchPacmedDrugsAnalytics: { loading: false, error: null, data: null, fetchType: null },
    fetchTopPharmaciesAnalytics: { loading: false, error: null, data: null, fetchType: null },
    fetchPackmedPharmacyList: { loading: false, error: null, data: null, fetchType: null }
};

// Helper function to update state
const updateState = (state, key, updates) => ({
    ...state,
    [key]: { ...state[key], ...updates }
});

// Reducer
const PackagingReducer = (state = initialState, { type, payload }) => {
    const actionPrefixMap = {
        TODAY_PROCESSING: 'todayProcessingData',
        ADD_PACKAGING_DATA: 'addPackagingData',
        PACKING_WIZARD_DATA: 'packingWizardData',
        STOCK_USAGE_DATA: 'stockUsageData',
        PACKAGING_ORDER_PREVIEW: 'packagingOrderPreviewData',
        PACKMED_FILES: 'packmedFiles',
        ALL_ORDERS: 'allOrders',
        PRN_PROCESSING: 'prnProcessingData',
        PACKING_LIQUID_PROCESSING: 'packgingLiquidProcessingData',
        ORDER_DETAILS: 'orderDetails',
        VIEW_ORDER_DETAILS: 'viewOrderDetails',
        ALL_INVOICES: 'allInvoices',
        INVOICE_DETAILS: 'invoiceDetails',
        FETCH_PHARMACY_PHARMACIST: 'fetchPharmacyPharmacist',
        FETCH_PARTIAL_ORDERS: 'fetchPartialOrders',
        FETCH_DASHBOARD_COUNTS: 'fetchDashboardCounts',
        FETCH_PACKAGING_CART_LIST: 'fetchPackagingCartList',
        DELETE_PACKAGE_CART: 'deletePackageCart',
        STOCK_LOG: 'stockLog',
        FETCH_DRUG_FAMILY_DATA: 'fetchDrugFamilyData',
        FETCH_TOP_DRUGS_ANALYTICS: 'fetchTopDrugsAnalytics',
        FETCH_DRUGS_SUMMARY_ANALYTICS: 'fetchDrugsSummaryAnalytics',
        FETCH_PACMED_DRUGS_ANALYTICS: 'fetchPacmedDrugsAnalytics',
        FETCH_TOP_PHARMACIES_ANALYTICS: 'fetchTopPharmaciesAnalytics',
        FETCH_PACKMED_PHARMACY_LIST: 'fetchPackmedPharmacyList'
    };
    const typeParts = type.split('_');// Splits action type string (e.g., "ADD_PACKAGING_DATA_SUCCESS")
    const status = typeParts.pop();   // Extracts last word (e.g., "SUCCESS")
    const prefix = typeParts.join('_'); // Joins remaining words (e.g., "ADD_PACKAGING_DATA")
    const key = actionPrefixMap[prefix];
    if (!key) return state;

    const updates = {
        REQUEST: { loading: true, ...(payload.requestType !== 'stockViewOrderDetails' && { data: null }), error: null, fetchType: payload.requestType },
        SUCCESS: { loading: false, error: null, data: payload.data, fetchType: payload.requestType },
        FAILURE: { loading: false, error: payload.error, data: null, fetchType: payload.requestType }
    }[status];


    return updates ? updateState(state, key, updates) : state;

    
};

export default PackagingReducer;
